<script lang="ts">
  import { PLATE_COPY } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { session } from "../net/session.svelte.js";
  import { send } from "../net/intents.js";
  import SurgeHandle from "./SurgeHandle.svelte";

  const snap = $derived(ship.snap!);
  const b = $derived(snap.breakers);
  const r = $derived(snap.relay);
</script>

<div class="console">
  <h3>BRIDGE CONSOLE</h3>
  <div class="block" aria-live="polite">
    <h3>BREAKER RESET PROCEDURE</h3>
    {#if b.status === "idle"}
      <p class="dim">ALL BREAKERS NOMINAL. NO PROCEDURE PENDING.</p>
    {:else}
      <p class="warn">BREAKER FAULT — RELAY THIS SEQUENCE TO THE OPERATOR AT THE BREAKER BAY:</p>
      {#if b.onPlate}
        <p class="warn">{PLATE_COPY.procedure}</p>
      {:else}
      <p class="seq">
        {#each b.required as id, i}
          <span class={i < b.flipped.length ? "done" : ""}>{id}</span>{#if i < b.required.length - 1} → {/if}
        {/each}
      </p>
      {/if}
      <p class="dim">{b.status === "lockout" ? "PANEL LOCKED — PROGRESS CLEARED" : `${b.flipped.length} / ${b.required.length} CONFIRMED`}</p>
    {/if}
  </div>
  {#if r.status === "damaged" || r.status === "carried"}
    <div class="block" aria-live="polite">
      <h3>INTERCOM RELAY — SOCKET 3</h3>
      {#if r.status === "damaged"}
        <p class="bad">RELAY DAMAGED. INTERCOM DEGRADED SHIP-WIDE. SPARE IN STORAGE (LADDER FROM REACTOR CONTROL).</p>
      {:else if r.carrier === session.sessionId}
        <button onclick={() => send("replace.socket", {})}>SOCKET SPARE RELAY</button>
      {:else}
        <p class="warn">SPARE EN ROUTE WITH {snap.crew[r.carrier]?.name ?? "A CREW MEMBER"}.</p>
      {/if}
    </div>
  {/if}
  <div class="block">
    <h3>SURGE DUMP — HANDLE B</h3>
    <SurgeHandle handleId="B" />
  </div>
</div>

<style>
  .console { display: grid; gap: 1rem; }
  .block { border: 1px solid var(--fg-dim); padding: 0.7rem; }
  .seq { font-size: 1.6em; letter-spacing: 0.1em; }
  .done { color: var(--fg-dim); text-decoration: line-through; }
</style>
